/**
 * "4:5" → 0.8. Devuelve `null` si el valor no es un par de números positivos: la
 * columna `imagenes_generadas.formato` es texto libre y una miniatura con
 * `aspect-ratio: NaN` (o 0, o Infinity) desaparece.
 *
 * Vive acá y no adentro de `useCreacionesRecientes` porque la necesitan dos
 * consumidores más — ADR-2026-09-06-el-visor-prestado-abre-por-id y
 * ADR-2026-09-06-carrusel-y-animar-aterrizan-en-la-columna: el visor prestado calcula
 * con esto la proporción de los recuadros de la tanda que delega (Carrusel / Animar).
 */
export function ratioDeFormato(formato: string | null | undefined): number | null {
  if (!formato) return null;
  const partes = formato.split(":");
  if (partes.length !== 2) return null;
  const [a, b] = partes.map((n) => Number(n.trim()));
  if (!Number.isFinite(a) || !Number.isFinite(b) || a <= 0 || b <= 0) return null;
  return a / b;
}

export default ratioDeFormato;
